import { z } from "zod";
/** ISO 8601 timestamp in UTC with a trailing Z. */
export const Timestamp = z.iso.datetime().meta({ id: "Timestamp" });
export const IsoDate = z.iso.date().meta({ id: "IsoDate" });
//# sourceMappingURL=time.js.map